import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { KeyRound } from "lucide-react";

interface RememberCredentialsDialogProps {
  open: boolean;
  onRemember: () => void;
  onDecline: () => void;
}

export const RememberCredentialsDialog = ({
  open,
  onRemember,
  onDecline,
}: RememberCredentialsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onDecline(); }}>
      <DialogContent className="mx-4 max-w-sm">
        <DialogHeader className="items-center text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <KeyRound className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle>Remember your credentials?</DialogTitle>
          <DialogDescription>
            Would you like the app to remember your login credentials for faster sign-in next time? 
            Your credentials will be stored securely on this device.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={onRemember} className="w-full">
            Remember
          </Button>
          <Button variant="outline" onClick={onDecline} className="w-full">
            Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
